import { useMutation } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { DocumentDataExclusionReasons, DocumentDataStatusFilters } from '../../../types/packager-types';

type IUseDocumentDataUpdateProps = {
  docDataId: string;
  exclusionReason?: DocumentDataExclusionReasons;
  escalationDetail?: string;
  status?: DocumentDataStatusFilters;
};

export const useDocumentDataUpdate = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IUseDocumentDataUpdateProps) => {
      return await (await glynt).documentData.update(data.docDataId, {
        exclusionReason: data.exclusionReason,
        escalationDetail: data.escalationDetail,
        status: data.status,
      });
    },

    ...callbacks
  });
};
